import gql from 'graphql-tag';

/**
 * 获取签到配置
 */
export const fetchCheckinRewardsConfigDocument = gql`
  query checkinRewardsConfig {
    checkinRewardsConfig {
      content
      dailyPrizeDay {
        id
        checkinPrizes {
          prizeType
          quantity
          coupon {
            name
            whetherRestrictUsers
            memberPlanIds
            residualNumber
            type
          }
        }
      }
    }
  }
`;

/**
 * 获取签到记录
 */
export const fetchCustomerCheckinRecordsDocument = gql`
  query customerCheckinRecords($input: CustomerCheckinRecordsInput) {
    customerCheckinRecords(input: $input) {
      id
      checkinDate
    }
  }
`;

/**
 * 获取连签天数
 */
export const fetchConsecutiveDaysDocument = gql`
  query consecutiveDays {
    consecutiveDays {
      consecutiveDays
      isCheckedIn
    }
  }
`;

/**
 * 获取连签奖励
 */
export const fetchCustomerPrizeRecordsDocument = gql`
  query customerPrizeRecords {
    customerPrizeRecords {
      eligiblePrizes {
        checkinPrizes {
          prizeType
          quantity
          coupon {
            name
            whetherRestrictUsers
            memberPlanIds
            residualNumber
            type
          }
        }
        days
      }
      receivedPrizeRecords {
        checkinPrizeDay {
          days
          checkinPrizes {
            prizeType
            quantity
            coupon {
              name
              whetherRestrictUsers
              memberPlanIds
              residualNumber
              type
            }
          }
        }
        checkinPrizes {
          prizeType
          quantity
          coupon {
            name
            whetherRestrictUsers
            memberPlanIds
            residualNumber
            type
          }
        }
      }
    }
  }
`;

/**
 * 签到
 */
export const fetchCustomerCheckinDocument = gql`
  mutation customerCheckin {
    customerCheckin {
      success
      message
    }
  }
`;
